import {
    DashboardState,
    EmployerDashboard,
    DashboardEnrollment
} from "@/employer/types";
import * as UserService from "@/shared/api/userService";
import { FetchState } from "@/shared/types";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";
import { useUserStore } from "@/shared/store/user";

export const initialState: DashboardState = {
    fetchState: FetchState.Uninitialized,
    dashboard: null
};

const defaultEnrollment: DashboardEnrollment = {
    enrolled: 0,
    inProgress: 0,
    notStarted: 0,
    percentageEnrolled: 0,
    total: 0,
    pendingInvitations: 0
};

export const useDashboardStore = defineStore("dashboard", {
    state: (): DashboardState => (_.cloneDeep(initialState)),
    getters: {
        enrollment () {
            return this.showDashboard ? this.dashboard.enrollment : { ...defaultEnrollment };
        },
        showDashboard: state => state.fetchState === FetchState.Loaded
    },
    actions: {
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },
        setDashboard (dashboard: EmployerDashboard) {
            this.dashboard = dashboard;
        },
        initDashboard () {
            if (this.fetchState !== FetchState.Uninitialized) {
                return Promise.resolve();
            }
            const userStore = useUserStore();
            if (!userStore.employerId) {
                return;
            }
            this.setFetchState(FetchState.Loading);
            return UserService.getEmployerDashboard(userStore.employerId)
                .then(response => {
                    this.setDashboard(response.data);
                    this.setFetchState(FetchState.Loaded);
                })
                .catch(err => {
                    this.setFetchState(FetchState.Loaded);
                    storeHelper.handleError({ error: err, rethrow: false });
                });
        }
    }
});